import styled from '@emotion/styled';

const Insta:React.FC<any> = () => {
  const handleInsta = () => {
    window.open("https://instagram.com/photypeta_official/tagged", "_blank");
    // window.location.href="https://instagram.com/photypeta_official/tagged/"
  }

  return (
    <Container>
      <BodyImgContainer>
        <Img src="/images/newLanding/home/insta.png"/>
      </BodyImgContainer>
      {/* <Title>엄마의 사랑이<br/> 가득한 후기</Title> */}
      <Title>인스타그램 후기</Title>
      <SmallText>@photypeta_official을 팔로우 하고 <br/>구독자들의 후기를 확인하세요.</SmallText>
      <SmallText 
        className="bottom"
        onClick={handleInsta}
      >
        FOLLOW PHOTYPETA
      </SmallText>
    </Container>
  )
};

export default Insta;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fcf7ef;
`;

const BodyImgContainer = styled.div`
margin-top: 30px;
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  display: flex;
  margin: 40px auto 30px;
  text-align: center;
`;

const SmallText = styled.div`
  margin: 0 auto 30px;
  text-align: center;
  font-size: 14px;
  
  &.bottom {
    margin-top: 10px;
    font-size: 15px;
    letter-spacing: 2px;
    margin-bottom: 150px;
    text-decoration: underline;
    text-underline-offset: 15px;
    text-decoration-color: #f0Ede7;
  }
`;